/**
 * update fix
 *
 * @format
 */

import api from "../../../utils/api";
import { planningService } from "../constant";
const basePath = `${planningService}/jadwal-pengajuan`;
const basePathFile = `${planningService}/doc-template`;

/** Post  Tanggal Pengajuan BOS  */
export const postTanggalPengajuanBOS = async (params: any) => {
  const response = await api.post<any>(`${basePath}`, params);
  return response?.data?.return;
};

/** Edit Rencana Tanggal Pengajuan BOS  */
export const editTanggalPengajuanBOS = async (params: any, id: any) => {
  const response = await api.put<any>(`${basePath}/${id}`, params);
  return response?.data?.return;
};

/** Delete RencanaTanggal Pengajuan BOS */
export const deleteTanggalPengajuanBOS = async (id: string) => {
  const response = await api.delete(`${basePath}/${id}`);
  return response?.data?.return;
};

/** Post  Dokumen Pengajuan BOS  */
export const postDokumenPengajuanBOS = async (params: any) => {
  const response = await api.post<any>(`${basePathFile}`, params);
  return response?.data?.return;
};

/** Edit Dokumen Pengajuan BOS  */
export const editDokumenPengajuanBOS = async (params: any) => {
  const id = params.id;
  const response = await api.put<any>(`${basePathFile}/${id}`, params);
  return response?.data?.return;
};

/** Delete Dokumen Pengajuan BOS */
export const deleteDokumenPengajuanBOS = async (id: string) => {
  const response = await api.delete(`${basePathFile}/${id}`);
  return response?.data?.return;
};
